import { FC } from "react";
import ReactApexChart from "react-apexcharts";

const PolarChart: FC = () => {
  const series = [42, 47, 52, 58, 65];
  const options: object = {
    chart: {
      width: "100%",
      type: "polarArea",
    },
    labels: ["Sale A", "Sale B", "Sale C", "Sale D", "Sale E"],
    colors: ["#62549c", "#7566b5", "#7d6cbb", "#8877bd", "#9181bd", "#6957af"],
    fill: {
      opacity: 1,
    },
    stroke: {
      width: 1,
      colors: undefined,
    },
    yaxis: {
      show: false,
    },
    xaxis: {
      show: false,
    },
    legend: {
      show: false,
    },
    plotOptions: {
      polarArea: {
        rings: {
          strokeWidth: 0,
        },
        spokes: {
          strokeWidth: 0,
        },
      },
    },
  };
  return (
    <ReactApexChart
      options={options}
      series={series}
      type="polarArea"
      height={350}
      width="100%"
    />
  );
};

export default PolarChart;
